import Requests from '@/helpers/Request';

export default {
  namespaced: true,
  state: () => ({
    headline: '',
    color: '',
    headlineColor: '',
    headlineTextColor: '',
    roomTextColor: '',
    roomnameLeft: '52vw',
    roomnameTop: '20vh',
    buildingTextColor: '',
    buildingnameLeft: '52vw',
    buildingnameTop: '30vh',
    bgColor: '',
    dateBgColor: '',
    dateTextColor: '',
    dateBorderColor: '',
    activeAppBorderColor: '',
    activeAppTitleColor: '',
    activeAppBgColor: '',
    appBorderColor: 'transparent',
    appBarColor: '',
    appBarTextColor: '',
    appBgColor: '',
    appSubtitleColor: '',
    appBarIconColor: '',
    appBarHeight: '20',
    appBarBottom: '5',
    activeLangColor: '',
    activeLangBorderColor: '',
    activeLangBgColor: 'transparent',
    langColor: '',
    langBorderColor: 'transparent',
    langBgColor: 'transparent',
    vodBgColor: '',
    vodFooterBorderColor: '',
    vodButtonColor: '',
    vodBorderColor: '',
    vodTextColor: '',
    vodListTextColor: '',
    bgImageVodUrl: '',
    isShowVodBackgroundImage: true,
    activeVodButtonColor: '',
    SVGAppColor: '',
    isShowHeadline: false,
    isShowBackgroundImage: true,
    isShowRoom: true,
    isShowRoomHeader: false,
    isShowBuilding: true,
    isShowDate: true,
    isShowDateBorder: false,
    bgImageUrl: '',
    bgImageWelcomeUrl: '',
    welcomeMessageColor: '',
    welcomeDetailColor: '',
    welcomeDetailActiveColor: '',
    welcomeDetailActiveBackgroundColor: '',
    welcomeCustomerNameColor: '',
    welcomeTextColor: '',
    welcomeLang: null,
    buildingId: '',
    id: '',
    language: {
      en: {
          "show" : true,
          "position" : 1
      },
      de: {
          "show" : true,
          "position" : 2
      },
      ch_de: {
          "show" : true,
          "position" : 3
      },
      ch_fr: {
          "show" : true,
          "position" : 4
      },
      ch_it: {
          "show" : true,
          "position" : 5
      },
      fr: {
          "show" : true,
          "position" : 6
      },
      it: {
          "show" : true,
          "position" : 7
      },
      es: {
          "show" : true,
          "position" : 8
      },
      ru: {
          "show" : true,
          "position" : 9
      },
      tr: {
          "show" : true,
          "position" : 10
      },
      ar: {
          "show" : false,
          "position" : 11
      },
      nl: {
          "show" : false,
          "position" : 12
      },
      ko: {
          "show" : false,
          "position" : 13
      },
      el: {
          "show" : false,
          "position" : 14
      },
      pt: {
          "show" : false,
          "position" : 15
      },
      hu: {
          "show" : false,
          "position" : 16
      },
      da: {
          "show" : false,
          "position" : 17
      },
      sv: {
          "show" : false,
          "position" : 18
      }
    }
  }),
  mutations: {
    setCustomizerValues(state, context) {
      for (const item in context) {
        state[item] = context[item];
      }
    },
  },
  actions: {
    async fetchCustomizerSettings({ commit, rootState }) {
      try {
        const response = await Requests.get(
          `${process.env.API_PORTAL}/bid/${rootState.buildingId}/customizer`
        );
        commit('setCustomizerValues', response[0]);
        return Promise.resolve();
      } catch (err) {
        console.log('Error in fetchCustomiyerSettings', err);
        return Promise.resolve();
      }
    },
  },
  getters: {
    getHomeBackground(state) {
      if (state.isShowBackgroundImage && state.bgImageUrl) {
        return `url(${state.bgImageUrl}) top left / cover no-repeat`;
      }
      return state.bgColor;
    },
    getVodBackground(state) {
      if (state.isShowVodBackgroundImage && state.bgImageVodUrl) {
        return `url(${state.bgImageVodUrl}) top left / cover no-repeat`;
      }
      return state.vodBgColor;
    },
    getHomeStyles(state, getters) {
      return {
        background: getters.getHomeBackground,
      };
    },
    getLanguages(state, getters) {
      return state.language;
    },
    getHeadlineTextStyles(state, getters) {
      var style = {};
      if(state.isShowHeadline) {
        style = {
          color: state.headlineTextColor,
          backgroundColor: state.headlineColor,
        };
      } else {
        style = {
          color: state.headlineTextColor,
          backgroundColor: 'transparent',
          height: '10vh',
          fontSize: '4vh',
        };
      }
      return style;
    },
    getLangImgStyle(state, getters) {
      var style = {};
      if(state.isShowHeadline) {
        style = {};
      } else {
        style = {
          marginRight: '1.5vh',
          maxHeight: '3.5vh',
        };
      }
      return style;
    },
    getLangStyle: (state) => (isActive) => {
    //getLangStyle (state, getters) {
      var style = {};
      //if(state.isShowHeadline) {
      //console.log("===========================================================getLangStyle", isActive);
      if (isActive) {
        style = {
          color: state.activeLangColor,
          borderColor: state.activeLangBorderColor,
          //border: '0.3vh solid #010101',
          borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.activeLangBgColor,
        };
      } else {
        style = {
          color: state.langColor,
          borderColor: state.langBorderColor,
          //border: '0.3vh solid #010101',
          borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.langBgColor,
        };
      }
      return style;
    },
    getBackStyle: (state) => (isActive) => {
    //getLangStyle (state, getters) {
      var style = {};
      //if(state.isShowHeadline) {
      //console.log("===========================================================getLangStyle", isActive);
      if (isActive) {
        style = {
          color: state.activeLangColor,
          borderColor: state.activeLangBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.activeLangBgColor,
        };
      } else {
        style = {
          color: state.langColor,
          borderColor: state.langBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.langBgColor,
        };
      }
      return style;
    },
    getBackStyleVod: (state) => (isActive) => {
    //getLangStyle (state, getters) {
      var style = {};
      //if(state.isShowHeadline) {
      //console.log("===========================================================getLangStyle", isActive);
      if (isActive) {
        style = {
          color: state.activeLangColor,
          borderColor: state.activeLangBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.activeLangBgColor,
        };
      } else {
        style = {
          color: state.langColor,
          borderColor: state.langBorderColor,
          //border: '0.3vh solid #010101',
          //borderWidth: '0.3vh',
          //bgColor: 'transparent',
          backgroundColor: state.langBgColor,
        };
      }
      return style;
    },
    getHotelnameTextStyles(state, getters) {
      return {
        color: state.buildingTextColor,
        left: state.buildingnameLeft,
        top: state.buildingnameTop
      };
    },
    getRoomnameTextStyles(state, getters) {
      return {
        color: state.roomTextColor,
        left: state.roomnameLeft,
        top: state.roomnameTop
      };
    },
    getAppSVGStyle: (state) => {
      return {
        fill: state.SVGAppColor,
      };
    },
    getAppStyles: (state) => (isActive) => {
      if (isActive) {
        return {
          borderColor: state.activeAppBorderColor,
          backgroundColor: state.activeAppBgColor,
          color: state.activeAppTitleColor,
          borderWidth: '5px',
          height: state.appBarHeight + "vh",
          marginBottom: state.appBarBottom + "vh",
          //fill: state.SVGAppColor,
        };
      }
      return {
        borderColor: state.appBorderColor,//"rgba(50,50,50,0.0)",//state.appBorderColor,/* 'transparent', TODO: state.appBorderColor, */
        backgroundColor: state.appBgColor,
        height: state.appBarHeight + "vh",
        marginBottom: state.appBarBottom + "vh",
        color: state.appBarTextColor,
        //fill: state.SVGAppColor,
      };
    },
    getDateStyles(state, getters) {
      var style = {};
      if(state.isShowHeadline) {
        style = {
          textAlign: 'left',
          color: state.dateTextColor,
        };
      } else if(state.isShowDate && state.isShowDateBorder) {
        style = {
          color: state.dateTextColor,
          backgroundColor: state.dateBgColor,
          border: '1px solid',
          borderColor: state.dateBorderColor,
          textAlign: 'center',
        };
      } else if(state.isShowDate) {
        style = {
          color: state.dateTextColor,
          textAlign: 'left',
          fontWeight: '700',
          fontSize: '4.5vh',
          marginTop: '4vh',
        };
      }
      return style;
    },
    getAppTitleStyles: (state) => (isActive) => {
      if (isActive) {
        return {
          color: state.activeAppTitleColor,
        };
      }
      return {
        color: state.appBarTextColor,
      };
    },
    getAppSubtitleStyles: (state) => (isActive) => {
      if (isActive) {
        return {
          color: state.activeAppTitleColor,
        };
      }
      return {
        color: state.appSubtitleColor,
      };
    },
    getWelcomeValues(state) {
      return {
        welcomeMessageColor: state.welcomeMessageColor,
        welcomeDetailColor: state.welcomeDetailColor,
        welcomeDetailActiveColor: state.welcomeDetailActiveColor,
        welcomeDetailActiveBackgroundColor: state.welcomeDetailActiveBackgroundColor,
        welcomeCustomerNameColor: state.welcomeCustomerNameColor,
        welcomeTextColor: state.welcomeTextColor,
        welcomeLang: state.welcomeLang,
      };
    },
    getWelcomeBackground(state) {
      if(state.bgImageWelcomeUrl) {
        return `url(${state.bgImageWelcomeUrl}) top left / cover no-repeat`;
      }
      return state.bgColor;
    },
    getWelcomeStyles(state, getters) {
      var style = {};
      style = {
        color: state.welcomeTextColor,
        backgroundColor: state.dateBgColor,
        border: '1px solid',
        borderColor: state.dateBorderColor,
        textAlign: 'center',
        background: getters.getWelcomeBackground,
      };
      return style;
    },
    getVodValues(state) {
      //TODO: css style <- DB
      return {
        vodMessageColor: state.welcomeMessageColor,
        vodDetailColor: state.welcomeDetailColor,
        vodDetailActiveColor: state.welcomeDetailActiveColor,
        vodDetailActiveBackgroundColor: state.welcomeDetailActiveBackgroundColor,
        vodCustomerNameColor: state.welcomeCustomerNameColor,
        vodTextColor: state.welcomeTextColor,
        vodLang: state.welcomeLang,
      };
    },
    /*
    getVodBackground(state) {
      //vodBgImageUrl
      if(state.bgImageVodUrl) {
        return `url(${state.bgImageVodUrl}) top left / cover no-repeat`;
      }
      return state.bgColor;
    },
    */
    getVodStyles(state, getters) {
      var style = {};
      style = {
        color: state.dateTextColor,
        backgroundColor: state.dateBgColor,
        border: '1px solid',
        borderColor: state.dateBorderColor,
        textAlign: 'center',
        background: getters.getVodBackground,
      };
      return style;
    },
    getLanguage(state) {
      //return state.language;
      if(state.language) {
        return Object.values(state.language).filter((e) => e.show).sort((a, b) => (a.position > b.position ? 1 : -1));
        //console.log("==========GETLANGUAGE", state.language);
        /*return state.language.filter((product) => {
          return product.show
        });*/
      }
    },
  },
};

/*
    "welcomeMessageColor" : "#FFFFFF",
    "welcomeDetailColor" : "#FFFFFF",
    "welcomeDetailActiveColor" : "#FFFFFF",
    "welcomeDetailActiveBackgroundColor" : "#131F26",
    "welcomeCustomerNameColor" : "#0088CC",
    "welcomeTextColor" : "#131F26",
    "bgImageWelcomeUrl" : "https://portal.triax.biz/images/svg/portal.svg",
    "welcomeLang" : null,

    welcomeBgColor


    "vodBgColor" : "#008ea6",
    "vodFooterBorderColor" : "#ffffff",
    "vodButtonColor" : "#008ea6",
    "activeVodButtonColor" : "#ffffff",

    bgImageVodUrl
*/



// WEBPACK FOOTER //
// ./src/store/modules/customizer.js